export const EventCrewAssignmentState = {
  DRAFT: 'DRAFT',
  INVITED: 'INVITED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
} as const;
export type EventCrewAssignmentState =
  (typeof EventCrewAssignmentState)[keyof typeof EventCrewAssignmentState];
